import { Model } from "@vuex-orm/core";

export interface clientWebDomainEntity {
  clientWebDomainId: number;
  clientWebDomainName?: string | null;
  clientId: number;
  isActive?: boolean | null;
  statusId: number;
  createdOn: string;
  createdById: number;
  updatedOn: string;
  updatedById: number;
  tick: number;
}

export class clientWebDomainEntity extends Model {
  static entity = "clientWebDomainEntity";
  static primaryKey = "clientWebDomainId";
  static fields() {
    return {
      clientWebDomainId: this.number(0),
      clientWebDomainName: this.string(null),
      clientId: this.number(0),
      isActive: this.boolean(null),
      statusId: this.number(0),
      createdOn: this.attr(""),
      createdById: this.number(0),
      updatedOn: this.attr(""),
      updatedById: this.number(0),
      tick: this.number(0),
    };
  }
}
